export const taskNounModes = ["task", "todo"];
const nounsByMode = {
    task: {
        singular: "task",
        plural: "tasks",
        titleSingular: "Task",
        titlePlural: "Tasks",
    },
    todo: {
        singular: "todo",
        plural: "todos",
        titleSingular: "Todo",
        titlePlural: "Todos",
    },
};
export const taskNouns = (mode) => nounsByMode[mode];
//# sourceMappingURL=task-nouns.js.map